import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import CredentialsFooter from "@/components/footer/Footer";
import CredentialsHeader from "@/components/header/Header";

import CredentialsForm from "@/components/Form/Form";
import { OtpValidation } from "@/models/site-credentials/mobile/OtpValidation";
import { FormError } from "@/models/site-credentials/common/FormError";

import { useTranslation } from "react-i18next";

type Form = OtpValidation & FormError;

export default function AboutAssociateLoyaltyCard() {
  const history = useHistory();
  const { t } = useTranslation();

  const formState = useForm<Form>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });

  const {
    handleSubmit,
    clearErrors,
  } = formState;


  const onSubmit = () => {
    history.push("/site-credentials/loyaltycard/association");
  };

  return (
    <CredentialsForm
      id={"SetUserPassword"}
      autoComplete="on"
      form={formState}
      onSubmit={(e) => {
        clearErrors();
        handleSubmit(onSubmit)(e);
      }}
    >
      <CredentialsHeader
        title={t(
          "site_credentials.loyaltycard_association.about_information.title"
        )}
        subtitle={t(
          "site_credentials.loyaltycard_association.about_information.subtitle"
        )}
        previousStepBackXTimes={1}
      />
      <div
        role="note"
        aria-label={t("accessibility.signin.icons")}
        className="flex flex-col">
        <CredentialsFooter />
      </div>
    </CredentialsForm>
  );
}
